import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sensor-injections-view" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "text-h4" }
const _hoisted_4 = { class: "d-flex align-center" }
const _hoisted_5 = { class: "text-h4" }
const _hoisted_6 = { class: "d-flex align-center" }
const _hoisted_7 = { class: "text-h4" }
const _hoisted_8 = { class: "d-flex align-center" }
const _hoisted_9 = { class: "text-h4" }

import { ref, onMounted, computed, reactive } from 'vue'
import { useSensorInjectionStore } from './store'
import { SensorInjection } from './models/sensorInjection'


export default /*@__PURE__*/_defineComponent({
  __name: 'SensorInjectionsView',
  setup(__props) {

const sensorInjectionStore = useSensorInjectionStore()
const loading = ref(false)
const selectedSensorSettingId = ref<string | null>(null)
const selectedType = ref<string | null>(null)
const selectedCommandType = ref<string | null>(null)
const statusFilter = ref<string | null>(null)
const executeLoading = reactive<Record<string, boolean>>({})
const testLoading = reactive<Record<string, boolean>>({})
const toggleLoading = reactive<Record<string, boolean>>({})

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Config ID', key: 'sensorSettingId' },
  { title: 'Tipo', key: 'type' },
  { title: 'Setting ID', key: 'settingId' },
  { title: 'Comando', key: 'commandType' },
  { title: 'Reintentos', key: 'retryPolicy' },
  { title: 'Req. ACK', key: 'requiresAck' },
  { title: 'Confiabilidad', key: 'reliability' },
  { title: 'Activo', key: 'active' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

// Opciones para los filtros
const sensorSettingOptions = ref([
  { title: 'Sensor Config 1', value: 'sensorConfig1' },
  { title: 'Sensor Config 2', value: 'sensorConfig2' },
  { title: 'Sensor Config 3', value: 'sensorConfig3' },
])

const typeOptions = ref([
  { title: 'MQTT', value: 'mqtt' },
  { title: 'HTTP', value: 'http' },
  { title: 'TCP', value: 'tcp' },
  { title: 'UDP', value: 'udp' },
  { title: 'Serial', value: 'serial' },
])

const commandTypeOptions = ref([
  { title: 'Establecer Valor', value: 'SET_VALUE' },
  { title: 'Obtener Estado', value: 'GET_STATUS' },
  { title: 'Calibrar', value: 'CALIBRATE' },
  { title: 'Reiniciar', value: 'RESET' },
  { title: 'Configurar', value: 'CONFIG' },
  { title: 'Iniciar', value: 'START' },
  { title: 'Detener', value: 'STOP' },
  { title: 'Personalizado', value: 'CUSTOM' },
])

const statusOptions = ref([
  { title: 'Activo', value: 'active' },
  { title: 'Inactivo', value: 'inactive' },
  { title: 'Confiable', value: 'reliable' },
  { title: 'Requiere ACK', value: 'requiresAck' },
])

const sensorInjectionsList = computed(() => {
  let list = sensorInjectionStore.sensorInjections
  
  if (selectedSensorSettingId.value) {
    list = list.filter(item => item.sensorSettingId === selectedSensorSettingId.value)
  }
  
  if (selectedType.value) {
    list = list.filter(item => item.type === selectedType.value)
  }
  
  if (selectedCommandType.value) {
    list = list.filter(item => item.commandType === selectedCommandType.value)
  }
  
  if (statusFilter.value) {
    switch (statusFilter.value) {
      case 'active':
        list = list.filter(item => item.active)
        break
      case 'inactive':
        list = list.filter(item => !item.active)
        break
      case 'reliable':
        list = list.filter(item => item.isReliable())
        break
      case 'requiresAck':
        list = list.filter(item => item.requiresAck)
        break
    }
  }
  
  return list
})

// Estadísticas computadas
const totalInjections = computed(() => sensorInjectionStore.sensorInjections.length)
const activeCount = computed(() => sensorInjectionStore.sensorInjections.filter(item => item.active).length)
const reliableCount = computed(() => sensorInjectionStore.sensorInjections.filter(item => item.isReliable()).length)
const ackRequiredCount = computed(() => sensorInjectionStore.sensorInjections.filter(item => item.requiresAck).length)

const getTypeColor = (type: string) => {
  const colors: Record<string, string> = {
    mqtt: 'orange',
    http: 'green',
    tcp: 'blue',
    udp: 'purple',
    serial: 'red'
  }
  return colors[type] || 'grey'
}

const getTypeIcon = (type: string) => {
  const icons: Record<string, string> = {
    mqtt: 'mdi-message-processing',
    http: 'mdi-web',
    tcp: 'mdi-network',
    udp: 'mdi-network-outline',
    serial: 'mdi-cable-data'
  }
  return icons[type] || 'mdi-help-circle'
}

const getCommandTypeColor = (commandType: string) => {
  const colors: Record<string, string> = {
    'SET_VALUE': 'green',
    'GET_STATUS': 'blue',
    'CALIBRATE': 'orange',
    'RESET': 'red',
    'CONFIG': 'purple',
    'START': 'success',
    'STOP': 'error',
    'CUSTOM': 'grey'
  }
  return colors[commandType] || 'grey'
}

const getCommandTypeIcon = (commandType: string) => {
  const icons: Record<string, string> = {
    'SET_VALUE': 'mdi-cog',
    'GET_STATUS': 'mdi-information',
    'CALIBRATE': 'mdi-tune',
    'RESET': 'mdi-restart',
    'CONFIG': 'mdi-settings',
    'START': 'mdi-play',
    'STOP': 'mdi-stop',
    'CUSTOM': 'mdi-wrench'
  }
  return icons[commandType] || 'mdi-help-circle'
}

const refreshData = async () => {
  loading.value = true
  try {
    await sensorInjectionStore.getSensorInjections()
  } finally {
    loading.value = false
  }
}

const filterBySensorSetting = async (sensorSettingId: string | null) => {
  if (sensorSettingId) {
    loading.value = true
    try {
      await sensorInjectionStore.getSensorInjectionsBySensorSettingId(sensorSettingId)
    } finally {
      loading.value = false
    }
  } else {
    refreshData()
  }
}

const filterByType = async (type: string | null) => {
  if (type) {
    loading.value = true
    try {
      await sensorInjectionStore.getSensorInjectionsByType(type)
    } finally {
      loading.value = false
    }
  } else {
    refreshData()
  }
}

const filterByCommandType = async (commandType: string | null) => {
  if (commandType) {
    loading.value = true
    try {
      await sensorInjectionStore.getSensorInjectionsByCommandType(commandType)
    } finally {
      loading.value = false
    }
  } else {
    refreshData()
  }
}

const filterByStatus = () => {
  // El filtrado por estado se maneja en el computed
}

const addItem = () => {
  console.log('Add new sensor injection')
}

const editItem = (item: SensorInjection) => {
  console.log('Edit item:', item)
}

const deleteItem = (item: SensorInjection) => {
  console.log('Delete item:', item)
}

const executeInjection = async (item: SensorInjection) => {
  executeLoading[item.id] = true
  try {
    await sensorInjectionStore.executeSensorInjection(item.id)
    console.log(`Injection ${item.id} executed successfully`)
  } catch (error) {
    console.error('Error executing injection:', error)
  } finally {
    executeLoading[item.id] = false
  }
}

const testInjection = async (item: SensorInjection) => {
  testLoading[item.id] = true
  try {
    await sensorInjectionStore.testSensorInjection(item.id)
    console.log(`Injection ${item.id} tested successfully`)
  } catch (error) {
    console.error('Error testing injection:', error)
  } finally {
    testLoading[item.id] = false
  }
}

const toggleStatus = async (item: SensorInjection) => {
  toggleLoading[item.id] = true
  try {
    await sensorInjectionStore.toggleSensorInjectionStatus(item.id)
    await refreshData()
  } catch (error) {
    console.error('Error toggling status:', error)
  } finally {
    toggleLoading[item.id] = false
  }
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("h1", null, "Sensor Injections", -1),
                _createElementVNode("p", null, "Gestión de inyecciones de comandos a sensores", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  color: "primary",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createVNode(_component_v_icon, {
                            size: "40",
                            class: "mr-3"
                          }, {
                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                              _createTextVNode("mdi-injection-syringe")
                            ])),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_3, _toDisplayString(totalInjections.value), 1),
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-caption" }, "Total Inyecciones", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  color: "success",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_v_icon, {
                            size: "40",
                            class: "mr-3"
                          }, {
                            default: _withCtx(() => _cache[7] || (_cache[7] = [
                              _createTextVNode("mdi-check-circle")
                            ])),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(activeCount.value), 1),
                            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-caption" }, "Activas", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  color: "info",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_icon, {
                            size: "40",
                            class: "mr-3"
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode("mdi-shield-check")
                            ])),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(reliableCount.value), 1),
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-caption" }, "Confiables", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  color: "warning",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_v_icon, {
                            size: "40",
                            class: "mr-3"
                          }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-message-reply")
                            ])),
                            _: 1
                          }),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(ackRequiredCount.value), 1),
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-caption" }, "Requieren ACK", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: selectedSensorSettingId.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((selectedSensorSettingId).value = $event)),
                    filterBySensorSetting
                  ],
                  items: sensorSettingOptions.value,
                  label: "Filtrar por Configuración",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: selectedType.value,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((selectedType).value = $event)),
                    filterByType
                  ],
                  items: typeOptions.value,
                  label: "Filtrar por Tipo",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: selectedCommandType.value,
                  "onUpdate:modelValue": [
                    _cache[2] || (_cache[2] = ($event: any) => ((selectedCommandType).value = $event)),
                    filterByCommandType
                  ],
                  items: commandTypeOptions.value,
                  label: "Filtrar por Comando",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, {
              cols: "12",
              md: "3"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: statusFilter.value,
                  "onUpdate:modelValue": [
                    _cache[3] || (_cache[3] = ($event: any) => ((statusFilter).value = $event)),
                    filterByStatus
                  ],
                  items: statusOptions.value,
                  label: "Filtrar por Estado",
                  clearable: ""
                }, null, 8, ["modelValue", "items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: sensorInjectionsList.value,
                  loading: loading.value,
                  class: "elevation-1"
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode("Lista de Inyecciones de Sensores")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[15] || (_cache[15] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "success",
                          class: "ml-2",
                          onClick: addItem
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1
                            }),
                            _cache[17] || (_cache[17] = _createTextVNode(" Agregar Inyección "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.sensorSettingId": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: "blue",
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.sensorSettingId), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.type": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getTypeColor(item.type),
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getTypeIcon(item.type)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(item.type.toUpperCase()), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.commandType": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getCommandTypeColor(item.commandType),
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getCommandTypeIcon(item.commandType)), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(item.getCommandTypeDescription()), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.retryPolicy": _withCtx(({ item }) => [
                    _createVNode(_component_v_tooltip, { location: "top" }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_chip, _mergeProps(props, {
                          color: "purple",
                          variant: "outlined",
                          small: ""
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              left: "",
                              size: "small"
                            }, {
                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                _createTextVNode("mdi-restart")
                              ])),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(item.retryPolicy.maxRetries) + "x ", 1)
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(item.getRetryPolicyDescription()), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  "item.requiresAck": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: item.requiresAck ? 'success' : 'default',
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.requiresAck ? 'mdi-message-reply' : 'mdi-message-arrow-right'), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(item.requiresAck ? 'Sí' : 'No'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.reliability": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: item.isReliable() ? 'success' : 'warning',
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          left: "",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.isReliable() ? 'mdi-shield-check' : 'mdi-shield-alert'), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createTextVNode(" " + _toDisplayString(item.isReliable() ? 'Confiable' : 'Básica'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.active": _withCtx(({ item }) => [
                    _createVNode(_component_v_switch, {
                      modelValue: item.active,
                      "onUpdate:modelValue": ($event: any) => ((item.active) = $event),
                      loading: toggleLoading[item.id],
                      color: "success",
                      onChange: ($event: any) => (toggleStatus(item)),
                      "hide-details": "",
                      density: "compact"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "loading", "onChange"])
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (executeInjection(item)),
                      loading: executeLoading[item.id],
                      disabled: !item.active,
                      color: "success"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                            _createTextVNode("mdi-play")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode(" Ejecutar inyección ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick", "loading", "disabled"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (testInjection(item)),
                      loading: testLoading[item.id],
                      color: "info"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode("mdi-test-tube")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode(" Probar inyección ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick", "loading"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[23] || (_cache[23] = [
                            _createTextVNode("mdi-pencil")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                            _createTextVNode(" Editar inyección ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      size: "small",
                      icon: "",
                      variant: "text",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                            _createTextVNode("mdi-delete")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_tooltip, {
                          activator: "parent",
                          location: "top"
                        }, {
                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                            _createTextVNode(" Eliminar inyección ")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})